import { MustacheTag } from "./mustache-tag.model";
import { MustacheTagTypes } from "./mustache-tag-types.model";

export class MustacheTextTag implements MustacheTag {
  type = MustacheTagTypes.text;
  key: string;
  subKeys: null;
  value: string;

  constructor(key: string) {
    this.key = key;
  }
}